import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';
import { observer } from 'mobx-react';

import classes from './PagesNavBox.module.scss';
import { NavLink } from './NavLink/NavLink';
import { NavMenu } from './NavMenu/NavMenu';
import { systemService } from '../../../services/systemService';
import { AdditionalLinks } from './AdditionalLinks/AdditionalLinks';
import { NAV_ITEM_TYPE } from '../../../constants/system/headerSettings';
import { SolutionType } from '../../../constants/user-info/solutionType';
import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';
import { getDefaultUserNavLinksConfig } from './utils/getDefaultUserNavLinksConfig';
import { UserNavLinksConfig } from './PagesNavBox.settings';

type PagesNavBoxProps = {
  activeSolution: SolutionType;
};

const PagesNavBox = observer(({ activeSolution }: PagesNavBoxProps) => {
  const [userNavLinksConfig, setUserNavLinksConfig] = useState<UserNavLinksConfig>(
    getDefaultUserNavLinksConfig(),
  );

  const getUserNavLink = async () => {
    const { headerSettings } = await systemService.getUserNavLinks({
      solution: activeSolution,
    });

    const newUserNavLinksConfig: UserNavLinksConfig = {
      ...userNavLinksConfig,
      [activeSolution]: headerSettings,
    };

    setUserNavLinksConfig(newUserNavLinksConfig);
    localStorage.setItem(
      LOCAL_STORAGE_KEYS.USER_NAV_LINKS,
      JSON.stringify(newUserNavLinksConfig),
    );
  };

  useEffect(() => {
    getUserNavLink();
  }, [activeSolution]);
  // use default empty array if solution is not in config to avoid errors
  const userNavLinks = userNavLinksConfig[activeSolution] ?? [];

  return (
    <Box className={classes.box}>
      {userNavLinks.map((page) => {
        switch (page.type) {
          case NAV_ITEM_TYPE.LINK:
            return <NavLink label={page.label} path={page.path} key={page.path} />;
          case NAV_ITEM_TYPE.MENU:
            return <NavMenu label={page.label} menuItems={page.items} key={page.label} />;
          case NAV_ITEM_TYPE.ADDITIONAL_LINKS:
            return <AdditionalLinks links={page.items} key={page.label} />;
          default:
            return null;
        }
      })}
    </Box>
  );
});

export { PagesNavBox };
